var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoCameraDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_577_5339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_577_5339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.5833C11.0417 14.5833 11.9272 14.2187 12.6563 13.4896C13.3855 12.7604 13.7501 11.875 13.7501 10.8333C13.7501 9.79167 13.3855 8.90625 12.6563 8.17708C11.9272 7.44792 11.0417 7.08333 10.0001 7.08333C8.95841 7.08333 8.073 7.44792 7.34383 8.17708C6.61466 8.90625 6.25008 9.79167 6.25008 10.8333C6.25008 11.875 6.61466 12.7604 7.34383 13.4896C8.073 14.2187 8.95841 14.5833 10.0001 14.5833ZM10.0001 12.9167C9.41675 12.9167 8.92369 12.7153 8.52091 12.3125C8.11814 11.9097 7.91675 11.4167 7.91675 10.8333C7.91675 10.25 8.11814 9.75694 8.52091 9.35417C8.92369 8.95139 9.41675 8.75 10.0001 8.75C10.5834 8.75 11.0765 8.95139 11.4792 9.35417C11.882 9.75694 12.0834 10.25 12.0834 10.8333C12.0834 11.4167 11.882 11.9097 11.4792 12.3125C11.0765 12.7153 10.5834 12.9167 10.0001 12.9167ZM3.33341 17.5C2.87508 17.5 2.48272 17.3368 2.15633 17.0104C1.82994 16.684 1.66675 16.2917 1.66675 15.8333V5.83333C1.66675 5.375 1.82994 4.98264 2.15633 4.65625C2.48272 4.32986 2.87508 4.16667 3.33341 4.16667H5.95841L7.50008 2.5H12.5001L14.0417 4.16667H16.6667C17.1251 4.16667 17.5174 4.32986 17.8438 4.65625C18.1702 4.98264 18.3334 5.375 18.3334 5.83333V15.8333C18.3334 16.2917 18.1702 16.684 17.8438 17.0104C17.5174 17.3368 17.1251 17.5 16.6667 17.5H3.33341ZM16.6667 15.8333V5.83333H13.2917L11.7709 4.16667H8.22925L6.70841 5.83333H3.33341V15.8333H16.6667Z",
    fill: "#1B75BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCameraDark);
export default __webpack_public_path__ + "static/media/photo_camera_dark.21dff1d0d4707741c5e5b7bd86f67fbe.svg";
export { ForwardRef as ReactComponent };